import React, { useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHAreaIns } from "services/services-mia/RNHAreaIns";
import wellknown from "wellknown";

const wktPolygonSchema = yup.string()
    .required("Debe ingresar las coordenadas WKT")
    .test('valid-wkt-format', 'Formato de coordenadas inválido', function(value) {
        if (!value || !value.trim()) {
            return this.createError({ message: 'Ingrese las coordenadas' });
        }
        const wktString = `POLYGON((${value.trim()}))`;
        const parsed = wellknown.parse(wktString);
        
        if (!parsed) {
            return this.createError({ 
                message: 'El formato de las coordenadas no es válido'
            });
        }
        if (parsed.type !== 'Polygon') {
            return this.createError({ 
                message: 'Las coordenadas no forman un polígono válido'
            });
        }
        const coords = parsed.coordinates[0];
        if (coords.length < 4) {
            return this.createError({ 
                message: `Se requieren mínimo 4 coordenadas. Tienes ${coords.length - 1}.`
            });
        }
        return true;
    });

export default function InsertModal({ updateList, servicio, closeModal, filtro }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [zonas, setZonas] = useState(filtro);
    const formikRef = useRef();

    const handleCreateArea = async (values) => {
        const response = await RNHAreaIns(
            credentials,
            { zonaId: values.zonaId, wkt: values.wkt, nombre: values.nombre, cod: values.cod },
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Area creada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                zonaId: "",
                cod: "",
                wkt: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    zonaId: yup.string("Debe seleccionar una zona").required("Debe ingresar una zona"),
                    cod: yup.string("Debe ingresar un Código").required("Debe ingresar un Código"),
                    wkt: wktPolygonSchema,
                })
            }
            onSubmit={(values) => {
                handleCreateArea(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikSelectInput
                            fullWidth={true}
                            name="zonaId"
                            labelText="Zona"
                            onChange={(e) => {
                                formikRef.current.setFieldValue("zonaId", e.target.value);
                            }}
                        >
                            <option value="" selected disabled >Seleccione</option>
                            {zonas.map(({ rnhZonaId, rnhZonaNombre }) => (
                                <option
                                    key={rnhZonaId}
                                    data-id={rnhZonaId}
                                    value={rnhZonaId}
                                >
                                    {rnhZonaNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            placeholder=""
                            labelText="Nombre del area"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            placeholder=""
                            labelText="Código del area"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="wkt"
                            placeholder=""
                            labelText="Poligono (Wkt)"
                            multiline
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
